import { lowerCaseValue } from './lowerCaseValue';

export function normalizeSearchQuery(query: string | undefined): string | undefined {
	// Normalize
	let normalized = lowerCaseValue(query);

	if (normalized) {
		// Replace commas with spaces
		normalized = normalized.replaceAll(',', ' ');

		// Consolidate spaces
		normalized = normalized.replace(/\s+/g, ' ');
	}

	return normalized;
}
